module.exports = __webpack_public_path__ + "assets/img/access_vector.f724dc7a.svg";